export const fill = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
} as const;

export const center = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
} as const;

export const unselectable = {
  cursor: 'default',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  userSelect: 'none',
} as const;

export const controlReset = {
  display: 'block',
  width: '100%', // button tag does not stretch by default
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  background: 'transparent',
  boxSizing: 'border-box',
  borderWidth: 0,
  borderRadius: 0,
  color: 'inherit',
  fontSize: 'inherit',
  fontFamily: 'inherit',
  outline: 0,
} as const;

export const oneLineText = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

export const unantialiasedFont = {
  WebkitFontSmoothing: 'auto',
  MozOsxFontSmoothing: 'auto',
} as const;
